<div class="background">
  <div class="card">
    <div class="content-holder">
      <p class="body-bold-20">Create a new password</p>
      <p class="caption12 margined">Use a minimum of 6 characters, including uppercase letters, lowercase
        letters, and numbers.</p>
      <p class="bordered"></p>
    </div>
    <form class="flex-form" [formGroup]="form" (ngSubmit)="submit()">
      <div class="form-outline">
        <app-text-input
          id="password"
          name="password"
          type="password"
          [label]="'general.password' | translate"
          [enablePasswordToggle]="true"
          [errorMessage]="'errors.invalid_password' | translate"
          [showError]="password.invalid && formSubmitAttempt"
          formControlName="password">
        </app-text-input>
      </div>
      <div class="form-outline" id="last-input">
        <app-text-input
          id="confirm-password"
          name="confirmPassword"
          type="password"
          [label]="'general.confirm_password' | translate"
          [enablePasswordToggle]="true"
          [errorMessage]="'errors.invalid_password' | translate"
          [showError]="(confirmPassword.invalid || form.hasError('passwordMatch')) && formSubmitAttempt"
          formControlName="confirmPassword">
        </app-text-input>
        <span *ngIf="confirmPassword.valid && form.hasError('passwordMatch') && formSubmitAttempt"
          class="error-text">{{'errors.passwords_dont_match' | translate}}</span>
      </div>

      <div class="form-outline flex center">
        <button type="submit" class="primary-blue-500 primary-sumbit">{{'general.send_reset_link' | translate}}</button>
      </div>
    </form>
  </div>
</div>
